import { css } from '@emotion/react';

const makeLegalStatementStyling = ({ theme }) => {
  return {
    legalStatement: css({
      marginTop: theme.mvf.spacing.small,
      marginBottom: theme.mvf.spacing.medium,
      '& p span': {
        color: '#808080',
        fontSize: `${theme.mvf.fontSize.originalTiny}px !important`,
        [theme.breakpoints.up('tabletSmall')]: {
          fontSize: `${theme.mvf.fontSize.originalLittle}px !important`,
        },
      },
    }),
  };
};

export default makeLegalStatementStyling;
